"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var themeContext_1 = require("../../utils/themeContext");
var Button = function (_a) {
    var _b = _a.transparent, transparent = _b === void 0 ? false : _b, _c = _a.wide, wide = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? 'button' : _d, _e = _a.size, size = _e === void 0 ? 'md' : _e, href = _a.href, children = _a.children, mainColor = _a.theme.mainColor, theme = _a.theme, className = _a.className, rest = __rest(_a, ["transparent", "wide", "type", "size", "href", "children", "theme", "theme", "className"]);
    // eslint-disable-next-line
    var component = href ? 'a' : 'button';
    return react_1.createElement(component, __assign(__assign({ className: classnames_1.default('aui-Button', "aui-Button_theme_" + mainColor, "aui-Button_size_" + size, { 'aui-Button_transparent': transparent }, { 'aui-Button_wide': wide }, className) }, (href ? { href: href } : { type: type })), rest), children);
};
Button.displayName = 'Button';
exports.default = themeContext_1.withTheme(Button);
